import { render, staticRenderFns } from "./ProcessMaterialEdit.vue?vue&type=template&id=4ac857d4&"
import script from "./ProcessMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./ProcessMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports